import * as React from "react";
import {default as ImageComponent} from "@project-stories/elements/ExtendedImage/ExtendedImage";
import {getImageUrl} from "@src/stories/components/Tile/TileMethods";

interface TileImageProps {
    data: any;
    height: any;
    isMobile: any;
    image_alt?: string;
}

const TileImage: React.FC<TileImageProps> = ({ data, height, isMobile, image_alt }) => {
    const imageUrl = getImageUrl(data, isMobile);
    const altText = image_alt || data.settings?.alt;

    return (
        <>
        {data.settings.image && (
                <div
                    className={`image-container ${data.settings.darken_image && "content-over-media"} relative`}
                >
                    <ImageComponent
                        imageUrl={imageUrl}
                        alt={altText}
                        classes={`object-cover h-[${height}] w-full`}
                        style={{ borderRadius: data.settings.media_rounding }}
                    />
                </div>
            )}
        </>
    );
};

export default TileImage;
